import React from 'react';

import SvgContainer from '../SvgContainer';

const ArrowDown = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9085_100954)">
                <path d="M2.18735 3.80279C1.77662 3.36724 1.08398 3.36724 0.673251 3.80279C0.295209 4.20367 0.295209 4.82975 0.673251 5.23063L7.27247 12.2285C7.66719 12.6471 8.33281 12.6471 8.72753 12.2285L15.3267 5.23063C15.7048 4.82975 15.7048 4.20367 15.3267 3.80279C14.916 3.36724 14.2234 3.36724 13.8126 3.80279L8 9.96658L2.18735 3.80279Z" />
            </g>
            <defs>
                <clipPath id="clip0_9085_100954">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default ArrowDown;
